module.exports = __webpack_public_path__ + "static/media/pizza.06d3a411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pizza.jpg
// module id = 35
// module chunks = 0